module.exports = __webpack_public_path__ + "static/img/home-img1.f456a1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img1.png
// module id = Bhy+
// module chunks = 1